import { useSelector } from 'react-redux'

import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { TranslationMode } from 'cng-common/features/translations/configs'
import { selectTranslationMode } from 'cng-common/features/translations/selectors'

interface IWidgetTourTextProps {
  /** A translation key. */
  text: string
  /** Shown while the key has no copy in the translation store. */
  fallback?: string
}

/** Tour text that a translator can edit in place: translation mode hands it to `Translation`,
 *  which renders the editable field, and every other mode resolves it as plain text. */
export const WidgetTourText = ({ text, fallback }: IWidgetTourTextProps) => {
  const t = useSafetyTranslation()
  const translationMode = useSelector(selectTranslationMode)

  if (translationMode === TranslationMode.Edit) {
    return <Translation text={text} span />
  }

  // `Translation` has no default value, so outside edit mode a key the store has no copy for
  // yet would render as the key rather than as its fallback.
  return <>{t(text, { defaultValue: fallback })}</>
}

WidgetTourText.displayName = 'WidgetTourText'
